
export enum FilterLabels {
  jobTitle = 'Job Title',
  jobDescription = 'Job Description',
  currency = 'Currency',
  publisher = 'Publisher',
  surveyCodeSurveyShortName = 'Survey',
}

export type FilterGroup = 'publisher' | 'surveyCodeSurveyShortName' 

export type Filter = string[] | null

export type VectorSearchFilters = {
  jobTitle: string
  jobDescription: string
  currency: Filter
  publisher: Filter
  surveyCodeSurveyShortName: Filter
}

export type SearchFilter = {
  [K in FilterGroup]: string[]
}
